import NumberFormat from "react-number-format";
import React from "react";
import Input from "../form-input/input"
import {FormContextConsumer} from "../../dynamic-form/dynamic-form-context";
import {substringWithNOccurrencesOfCharacter} from "../../../../utils";

//var protocolo = require('protocolo');

/*const isValidProtocolo = (value, metadata) => {
    const reg = new RegExp(metadata.regexp);
    const imeiNumber = parseInt(value);
    if (value) {
        return protocolo.isValid(imeiNumber.toString()) && reg.test(imeiNumber);
    } else {
        return !Boolean(metadata.required);
    }
};*/

const matchRegEx = (string, pattern) => {
    const regex = new RegExp(pattern);
    return regex.test(string);
};

const onChange = (setFormValues, formValues, metadata) => (event) => {
    setFormValues(metadata.name, event.target.value.replace(/\D/g,''),
        matchRegEx(event.target.value.replace(/\D/g,''), metadata.regexp));
};
/*const selectMask = (formValues, metadata) => {
    const phone = ((formValues[metadata.name] || {})["value"] || '');
    if (phone.length === 0) {
        return "######-##-######-#"
    }
    else {
        return substringWithNOccurrencesOfCharacter("######-##-######-#", "#", phone.length+1);
    }
};*/

export default function Protocolo({metadata}){
    const params = new URLSearchParams(window.location.search)
    let fieldDisabled = false;
    if (params.has('PACKAGE-ID')){
        if (metadata.updatable === false)
            fieldDisabled = true;
    }
    return (<FormContextConsumer>
        {({ setFormValues, formValues }) => (
            <NumberFormat customInput={Input}
                          id={metadata.name}
                          //format={selectMask(formValues, metadata)}
                          metadata={metadata}
                          mask={" "}
                          valid={matchRegEx(((formValues[metadata.name] || {})["value"] || ''), metadata.regexp) || !(metadata.required)}
                          onChange={onChange(setFormValues, formValues, metadata)}
                          isNumericString={true}
                          value={((formValues[metadata.name] || {})["value"] || '')}
                          disabled={fieldDisabled}
            />
        )}
    </FormContextConsumer>)
}
